module.exports = __webpack_public_path__ + "img/recycle.504ca90a.png";